import {isAssetCheckedOut} from '@netx/core-asset-next/utils/isAssetCheckedOut';
import {
	assetPermissionChecker,
	PermissionName,
	PermissionMatrixName,
} from '@netx/core-permissions-next';
import {canCreateShareLink} from '@netx/core-share-link/enablers/canCreateShareLink';
import {type IAsset} from '../schema';

export const canCreateShareLinkFromAsset = (asset?: IAsset): boolean => {
	if (asset == null) return false;
	if (isAssetCheckedOut(asset)) return false;
	if (!canCreateShareLink()) return false;
	return assetPermissionChecker({
		asset,
		permissionMatrixName: PermissionMatrixName.DOWNLOAD,
		permissionName: PermissionName.CREATE_SHARE_LINKS,
	});
};
